<template>
  <Layout>
    <b-row>
      <b-col md="1" />
      <b-col md="5">
        <Panel v-if="!loadingData">
          <div class="content">
            <b-row class="plan-header">
              <b-col md="12">
                <img src="../../../assets/themes/clippFacil/images/logo.png"
                  alt="Logo Clipp 360"
                  class="plan-logo"
                >
              </b-col>
            </b-row>
            <b-row>
              <b-col md="12" class="plan-content">
                <p v-for="option in options" :key="option.description">
                  <span :style="'color: ' + (option.isFacil ? '#96C11B' : '#e8e7e6')">
                    <Check size="16" />
                  </span>
                  <span class="plan-option">{{ option.description }}</span>
                </p>
              </b-col>
            </b-row>
            <b-row class="plan-ht-70"></b-row>
            <b-row class="plan-footer">
              <v-col class="plan-footer-content">
                <button class="btn btn-success plan-button button-facil"
                  @click="openUrl(
                    'https://api.whatsapp.com/send?phone=554840420031&text=Ol%C3%A1!%20Quero%20saber%20mais%20sobre%20o%20ClippF%C3%A1cil'
                  )">
                  Saiba mais
                </button>
              </v-col>
            </b-row>
          </div>
        </Panel>
      </b-col>
      <b-col md="5">
        <Panel v-if="!loadingData">
          <div class="content">
            <b-row class="plan-header">
              <b-col md="12">
                <img src="../../../assets/themes/clipp360/images/logo.png"
                  alt="Logo Clipp 360"
                  class="plan-logo"
                >
              </b-col>
            </b-row>
            <b-row>
              <b-col md="12" class="plan-content">
                <p v-for="option in options" :key="option.description">
                  <span :style="'color: ' + (option.is360 ? '#40cedb' : '#e8e7e6')">
                    <Check size="16" />
                  </span>
                  <span class="plan-option">{{ option.description }}</span>
                </p>
              </b-col>
            </b-row>
            <b-row class="plan-ht-70">
              <b-col md="12">
                <p class="plan-360">
                  Tudo do ClippFácil e mais <br>
                  funcionalidades exclusivas!
                </p>
              </b-col>
            </b-row>
            <b-row class="plan-footer">
              <v-col class="plan-footer-content">
                <button class="btn btn-success plan-button button-360"
                  @click="openUrl(
                    'https://api.whatsapp.com/send?phone=554840420031&text=Quero%20saber%20mais%20sobre%20o%20Clipp360'
                  )">
                  Saiba mais
                </button>
              </v-col>
            </b-row>
          </div>
        </Panel>
      </b-col>
    </b-row>
  </Layout>
</template>

<script>
import Check from 'vue-material-design-icons/Check';

import {
  Layout,
  Panel,
} from '../../../components';

export default {
  name: 'Payment',
  components: {
    Check,
    Layout,
    Panel,
  },
  data() {
    return {
      options: [
        {
          is360: true,
          isFacil: true,
          description: 'E-commerce eC4',
        },
        {
          is360: true,
          isFacil: true,
          description: 'App NFC-e',
        },
        {
          is360: true,
          isFacil: true,
          description: 'NF-e, NFC-e, CF-e SAT',
        },
        {
          is360: true,
          isFacil: false,
          description: 'Tela PDV frente de caixa',
        },
        {
          is360: true,
          isFacil: false,
          description: 'Replicação de dados',
        },
        {
          is360: true,
          isFacil: false,
          description: 'Parametrização de tributos',
        },
        {
          is360: true,
          isFacil: false,
          description: 'Shipay',
        },
        {
          is360: true,
          isFacil: false,
          description: 'Sintegra',
        },
        {
          is360: true,
          isFacil: false,
          description: 'WhatsApp',
        },
        {
          is360: true,
          isFacil: false,
          description: 'MDF-e',
        },
      ],
    };
  },
  methods: {
    openUrl(url) {
      window.open(url, '_blank');
    },
  },
};
</script>

<style scoped>
  .content {
    padding: 20px;
  }

  p {
    font-size: 14px!important;
    font-size: 14px!important;
    line-height: initial;
  }

  .plan-header {
    text-align: center;
    padding-bottom: 50px;
  }

  .plan-content {
    padding-left: 40px;
  }

  .plan-option {
    margin-left: 15px;
  }

  .plan-ht-70 {
    height: 70px;
    display: flex;
    align-items: center
  }

  .plan-footer {
    text-align: center;
    display: block;
  }

  .plan-footer-content {
    text-align: center;
    margin-top: 30px;
  }

  .plan-360 {
    color: #40cedb;
    text-align: center;
    line-height: 20px!important;
  }

  .plan-logo {
    width: 50%;
  }

  .plan-button {
    border-radius: 20px;
    min-width: 40%;
    font-size: 16PX;
    min-height: 50px;
  }

  .button-360 {
    background-color: #40cedb;
  }

  .button-facil, .button-facil:focus, .button-facil:hover {
    background-color: #96C11B;
  }

  .panel {
    border-radius: 20px;
  }
</style>
